import { createApp } from 'vue'

import App from './App.vue'
import './styles/tokens.css'
import './styles/base.css'
import './styles/site.css'

createApp(App).mount('#app')
